import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IErrorInfo } from '../interfaces/iErrorInfo';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private router = inject(Router);
  private urlService = inject(UrlService);

  public redirectError(state: IErrorInfo) {
    const returnUrl = state.originalUrl
      ? state.originalUrl
      : this.urlService.getCurrentUrl();
    this.router.navigateByUrl(`/error?returnUrl=${btoa(returnUrl)}`, {
      state: { errorInfo: { ...state, originalUrl: `${returnUrl}` } }
    });
  }
}
